import { useState } from "react";
import { changePasswordApi } from "@/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

function formatErr(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  return "Etwas ist schiefgelaufen.";
}

// variant: "light" (on dark platform header) | "dark" (on white business header)
export const ChangePasswordButton = ({ variant = "dark" }) => {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCur(""); setPw(""); setConfirm(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Das neue Passwort muss mindestens 6 Zeichen haben."); return; }
    if (pw !== confirm) { toast.error("Die Passwörter stimmen nicht überein."); return; }
    setBusy(true);
    try {
      await changePasswordApi(cur, pw);
      toast.success("Passwort erfolgreich geändert ✓");
      reset(); setOpen(false);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  const btnCls = variant === "light"
    ? "bg-white/10 hover:bg-white/20 text-white"
    : "bg-slate-100 hover:bg-slate-200 text-slate-600";

  return (
    <>
      <button data-testid="change-password-open" onClick={() => setOpen(true)}
        className={`flex items-center gap-1.5 rounded-xl px-3 py-2 text-xs font-bold press whitespace-nowrap ${btnCls}`}>
        <KeyRound className="h-4 w-4" /> Passwort
      </button>
      <Dialog open={open} onOpenChange={(o) => { if (!busy) { setOpen(o); if (!o) reset(); } }}>
        <DialogContent className="rounded-3xl max-w-sm">
          <DialogHeader>
            <DialogTitle className="font-display text-xl">Passwort ändern</DialogTitle>
            <DialogDescription>Aus Sicherheitsgründen benötigen wir dein aktuelles Passwort.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div className="space-y-1.5">
              <label className="text-xs font-bold text-slate-500">Aktuelles Passwort</label>
              <Input data-testid="cp-current-input" type="password" value={cur} onChange={(e) => setCur(e.target.value)} placeholder="••••••••" className="h-11 rounded-xl" required autoComplete="current-password" />
            </div>
            <div className="space-y-1.5">
              <label className="text-xs font-bold text-slate-500">Neues Passwort</label>
              <Input data-testid="cp-new-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Mindestens 6 Zeichen" className="h-11 rounded-xl" required minLength={6} autoComplete="new-password" />
            </div>
            <div className="space-y-1.5">
              <label className="text-xs font-bold text-slate-500">Neues Passwort bestätigen</label>
              <Input data-testid="cp-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Wiederholen" className="h-11 rounded-xl" required minLength={6} autoComplete="new-password" />
            </div>
            <Button data-testid="cp-submit" type="submit" disabled={busy}
              className="w-full py-3 rounded-2xl bg-[var(--bs-teal)] hover:bg-[var(--bs-teal-hover)] font-display font-bold press disabled:opacity-60">
              {busy ? <><Loader2 className="mr-1 h-5 w-5 animate-spin" /> Speichern…</> : <><KeyRound className="mr-1 h-5 w-5" /> Passwort ändern</>}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
